module.exports = __webpack_public_path__ + "img/Gelangweilt.51580029.jpg";